import React from 'react';
import BreadcrumbComponent from '@views/components/breadcrumb/Breadcrumb';

export const Breadcrumb = () => (
  <BreadcrumbComponent
    options={[
      {
        name: 'Quản lý đơn hàng',
        active: true,
      },
    ]}
  />
);

export default Breadcrumb;
